import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import config from '../../config';

import AdminImportPage from '../shared/adminImportPage.component';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';
import AddEditModal from './addEditAdminTaxEntryModal.component';
import DeleteModal from './deleteAdminTaxEntryModal.component';
import TaxEntryAdminColumnRenderer from './taxEntryAdminColumnRenderer.component';
import { sharedActions } from './store/actions';
import downloadXlsxFile from './downloadXlsx';

import { withPermissions, permissions } from '../../shared/authorization';
import columnDefinitions from '../../shared/columnDefinitions/adminTaxEntrySettings';

const AdminTaxEntrySettingsPage = ({ canModifyInSelectedPeriod }) => {
  const generateTemplateFileName = useCallback(
    ({ periodName }) => `TLS_Balance_Sheet_Management_Admin_Tax_Entry_${periodName}`
    , []);

  return (
    <AdminImportPage
      pageName={adminPageNames.ADMIN_TAX_ENTRY_SETTINGS}
      pageTitle={adminPageTitles.ADMIN_TAX_ENTRY_SETTINGS}
      canModify={canModifyInSelectedPeriod}
      AddEditEntityModal={AddEditModal}
      RemoveEntityModal={DeleteModal}
      adminColumnRenderer={TaxEntryAdminColumnRenderer}
      addEntityMessage="Add Tax Entry"
      columnDefs={columnDefinitions}
      actions={sharedActions}
      comparatorConfig={{ idField: 'slAccount' }}
      exportToExcel={downloadXlsxFile}
      templatePath={config.templates.ADMIN_TAX_ENTRY}
      generateTemplateFileName={generateTemplateFileName}
    />
  );
};

AdminTaxEntrySettingsPage.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
};

export default withPermissions(permissions.OBLIGATIONS)(AdminTaxEntrySettingsPage);
